import { Images } from "./product.model";

export interface BaseReward {
    id?: number;
    userId: number;
    type: RewardType;
    source: RewardSource;
    amount: number;
    orderId: number;
    structureId?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum RewardType {
    Debited = "Debited",
    Credited = "Credited",
}

export enum RewardSource {
    Structure = "Structure",
    Order = "Order",
    Refund = "Refund",
}

export enum RewardRefundReason {
    Cancellation = "Cancellation",
    Return = "Return",
    PaymentFailure = "Payment Failure",
}

export interface RewardDetail {
    id: number;
    userId: number;
    coinsEarned: number;
    coinsSpent: number;
    orderId: number;
    productId: number;
    name: string | null;
    createdAt?: Date;
    type: string;
}

export interface RewardResponse {
    success: boolean;
    message: string;
    data: {
        userId: number;
        orderId: number;
        productId: number | null;
        coinsSpent: number;
    };
}

export interface Order {
    id: number;
    productId?: number;
}

export interface ProductReward {
    id: number;
    name: string;
    price: number;
    discountedPrice?: number;
    quantity: number;
    images?: Images;
}

export interface EmailContent {
    message: string;
    structureName?: string;
    productName?: string;
    coinsEarned?: number;
    structureImage?: string;
    orderId?: number;
    quantity?: number;
    price?: number;
    productImage?: string;
    coinsSpent?: number;
    creditedOn?: string | undefined;
    debitedOn?: string | undefined;
    source?: RewardSource;
    imageUrl?: string;
    isStructureReward?: boolean;
    isOrderSpend?: boolean;
    isRefund?: boolean;
}

export interface RewardDetails {
    coinsEarned?: number;
    creditedOn?: Date;
    coinsSpent?: number;
    debitedOn?: Date;
}

export enum RewardMessage {
    userNotFoundForStructure = "User not found for structure reward.",
    invalidRewardContext = "Invalid reward context or missing required data.",
}

export interface Item {
    structure: {
        dataValues: {
            id: number;
            userId: number;
            imageurl: string | string[];
            structureName: string;
        };
    };
    product: {
        dataValues: {
            id: number;
            name: string;
            image: {
                imagesUrl: string | string[];
            };
        };
    };
}
